import type { ReactNode } from 'react';
import { PageHeader } from '@/components/common/PageHeader';

/**
 * A minimal routed page body used by the shell so every nav destination renders
 * a real, titled page. Feature verticals (Mailboxes, Domains, …) will replace
 * these bodies with their tables/forms — this is the shell's content slot, not
 * a mock: it renders live breadcrumbs, header and the routed outlet region.
 */
export function RoutePage({ title, description, children }: {
  title: string;
  description?: string;
  children?: ReactNode;
}) {
  return (
    <div>
      <PageHeader title={title} description={description} />
      <div className="rounded-xl border border-border bg-surface p-6 text-fg-muted">
        {children ?? (
          <p className="text-sm">
            This section is part of the application shell. The {title} feature module renders here.
          </p>
        )}
      </div>
    </div>
  );
}
